// extracted by mini-css-extract-plugin
export var chip = "_49-0";
export var filterDropdown = "_49-5";
export var filterItem = "_49-6";
export var icon = "_49-1";
export var removeButton = "_49-3";
export var removeIcon = "_49-4";
export var separator = "_49-2";